import React from 'react';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { useHotKeyScope } from 'reactApp/hooks/useHotkeyScope';
import { useContent } from 'reactApp/ui/DiscountOnRemoveModal/DiscountOnRemoveModal.hooks';

import styles from './DiscountOnRemoveModal.css';

export interface DiscountOnRemoveModalProps {
    onClose(): void;
    onSuccess(): void;
    onAction(): void;
    onShow(): void;
}

export const HOT_KEY_SCOPE_NAME = 'DiscountOnRemoveModal';

export function DiscountOnRemoveModal({ onClose, onAction, onSuccess, onShow }: DiscountOnRemoveModalProps) {
    const { image, content, title, cancelButton, successButton } = useContent();
    useHotKeyScope(HOT_KEY_SCOPE_NAME);

    return (
        <WhatsNewDialog
            qaId="remove-discount-dialog"
            className={styles.root}
            onShow={onShow}
            onClose={onClose}
            onClick={onSuccess}
            onSecondary={onAction}
            primaryButtonText={successButton}
            secondaryButtonText={cancelButton}
            title={title}
            content={content}
            imageUrl=""
            imageOnlyAdditionalContent
            imageAdditionalContent={image}
            dialogSize="tiny"
        />
    );
}
